<script lang="ts">
	import { subHours } from 'date-fns';
	import type { Snippet } from 'svelte';

	interface Props {
		endDate: string;
		duration: number;
		text: string;
		children?: Snippet;
	}

	let { endDate, duration, text, children }: Props = $props();

	const countdownEnd = new Date(endDate);
	const countdownStart = subHours(countdownEnd, duration);

	let countdown: {
		now: Date;
		days: number;
		hours: number;
		minutes: number;
		seconds: number;
	} = $state({
		now: new Date(),
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0
	});

	let interval = setInterval(setCountdown, 1000);

	function setCountdown() {
		let distance = countdownEnd.getTime() - countdown.now.getTime();
		countdown = {
			now: new Date(),
			days: Math.floor(distance / (1000 * 60 * 60 * 24)),
			hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
			minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
			seconds: Math.floor((distance % (1000 * 60)) / 1000)
		};
		if (distance < 0) {
			clearInterval(interval);
		}
	}

	setCountdown();

	let splittedText = text.split('[countdown]');
</script>

{#if countdown.now < countdownEnd}
	{#if countdown.now < countdownStart}
		{@render children?.()}
	{:else}
		<p>
			{splittedText[0]}
			<span>
				{countdown.days * 24 + countdown.hours}H: {countdown.minutes}M: {countdown.seconds}S
			</span>
			{#if splittedText.length > 0}
				{splittedText[1]}
			{/if}
		</p>
	{/if}
{/if}
